import React from 'react'
import { Section } from '@shared/components/section'
import cx from 'classnames'

import styles from './style.module.scss'

interface Props {
	stepTextStyles?: string
	steps?: string[][]
}

const stepsDefault = [
	['Оставьте заявку онлайн за пару минут', styles.stepOne],
	['Сразу же узнайте предварительное решение', styles.stepTwo],
	['Получите деньги там, где вам удобно', styles.stepTree],
]

export const ViewContent = ({ stepTextStyles, steps = stepsDefault }: Props) => (
	<div className={styles.stepsWrapper}>
		{steps.map(([label, customClassName], i) => (
			<div key={label} className={styles.step}>
				<div className={cx(styles.stepNumber, customClassName)}>{i + 1}</div>
				<h3 className={cx(stepTextStyles ? stepTextStyles : styles.stepText)}>{label}</h3>
			</div>
		))}
	</div>
)

export const View = ({ steps }: Props) => (
	<Section className={styles.wrapper}>
		<ViewContent steps={steps} />
	</Section>
)
